import { Button, PopoverTrigger, Stack, Text, TextField, Tooltip, notify } from '@eleveo/components-react';
import { CheckmarkIcon, LinkIcon } from '@eleveo/icons-react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { useGetCalendarExportUrlQuery } from '../../../../graphql/components';
import { useClipboard } from '../../../../utils/useClipboard';
import { CALENDAR_EXPORT_COPY_BUTTON, CALENDAR_EXPORT_TOGGLE_BUTTON } from '../../constants';

type CalendarExportProps = {
  userId: string;
};

export const CalendarExport: React.FC<CalendarExportProps> = ({ userId }) => {
  const { t } = useTranslation();
  const [copied, copy] = useClipboard();

  const { data: calendarExportUrlData } = useGetCalendarExportUrlQuery({
    fetchPolicy: 'network-only',
    variables: {
      agentId: userId,
    },
  });

  const url = calendarExportUrlData?.getCalendarExportURL?.url;

  const handleCopy = () => {
    if (!url) {
      notify.error(t('layout.somethingWentWrong'));
    } else {
      copy(url);
    }
  };

  return (
    <Tooltip content={t('calendar.export.title')}>
      <PopoverTrigger className="calendar-export__content">
        <Button aria-label={t('calendar.export.title')} testId={CALENDAR_EXPORT_TOGGLE_BUTTON} variant="outline">
          <LinkIcon />
        </Button>
        <Stack direction="vertical" spacing={15}>
          <Text className="calendar-export__warning">
            <strong>{t('calendar.export.description')}</strong> {t('calendar.export.warning')}
          </Text>

          <TextField
            aria-label={t('calendar.export.fieldUrl')}
            className="w-full"
            defaultValue={url ?? ''}
            isReadOnly
            onFocus={(event) => event.target.select()}
          />

          <Button className="w-full" isSelected={copied} testId={CALENDAR_EXPORT_COPY_BUTTON} onClick={handleCopy}>
            {copied ? (
              <>
                <CheckmarkIcon /> {t('layout.action.copyClipboard.successMessage')}
              </>
            ) : (
              t('layout.action.copyClipboard.title')
            )}
          </Button>
        </Stack>
      </PopoverTrigger>
    </Tooltip>
  );
};
